// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-ranges button {
  padding: 0;
  width: 35px;
  height: 35px;
  margin-left: 0;
  font-weight: 600;
  line-height: 34px;
  text-align: center;
  box-shadow: unset !important;
  transition: var(--transition);
  text-decoration: none;
  font-size: 14px;
  background-color: transparent;
  border-radius: 0.25em !important;
  color: var(--splash-muted-color);
  border: 1px solid rgba(101, 96, 240, 0.15);
}
.survey-ranges button:hover {
  background-color: var(--splash-primary-color);
  border-color: var(--splash-primary-color);
  color: var(--splash-white-color);
}
.survey-ranges div {
  max-width: 150px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
